<template>
  <div v-loading="isLoading">
    <div class="row campaign-stats-filters">
      <div class="columns large-4 small-12 campaign-stats-filters__item">
        <CampaignBidsFilter v-model="filterModel.bids" />
      </div>
      <div class="columns large-3 small-12 campaign-stats-filters__item">
        <InputWithLabel
          :label="$t('ADVERTISEMENT.CAMPAIGN.STATS.BUILDER.CHART_TYPE')"
        >
          <ElCascader v-model="filterModel.chart" :options="filterOptions" />
        </InputWithLabel>
      </div>
      <div
        class="columns large-3 small-12 campaign-stats-filters__item campaign-stats-filters__item--without-label"
      >
        <RangeFilter v-model="filterModel.range" />
      </div>
    </div>
  </div>
</template>

<script>
import InputWithLabel from '@@/common/InputWithLabel';
import RangeFilter from '@@/common/RangeFilter';
import CampaignBidsFilter from './CampaignBidsFilter';

import { AdInsight } from '@/api/api';

export default {
  name: 'CampaignStatsFilters',
  components: {
    InputWithLabel,
    RangeFilter,
    CampaignBidsFilter,
  },
  data() {
    return {
      filterModel: {
        bids: [],
        chart: [],
        range: 'last-week',
        secondaryChart: [],
      },
      filterOptions: [],
      isLoading: true,
    };
  },
  computed: {
    hasCreateReportRequirement() {
      return (
        this.filterModel.bids.length &&
        this.filterModel.chart.length &&
        this.filterModel.range
      );
    },
  },
  watch: {
    filterModel: {
      deep: true,
      handler() {
        this.filterChanged();
      },
    },
  },
  created() {
    this.getFilters();
  },
  methods: {
    filterChanged() {
      if (!this.hasCreateReportRequirement) return;
      this.$emit('filterChanged', {
        ...this.filterModel,
      });
    },
    getFilters() {
      return AdInsight.getChartStatTypes()
        .then(({ statTypes, selected }) => {
          this.filterModel.chart = selected;
          this.filterOptions = statTypes;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.campaign-stats-filters {
  &__export-csv {
    margin-right: auto;
  }

  &__item {
    &--without-label {
      display: flex;
      align-items: flex-end;
    }
  }
}
</style>
